export default "__VITE_ASSET__CkWRm05G__"